// extracted by mini-css-extract-plugin
export default {"container":"submit_section_container__udIKL"};